// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BGMChart-module__font-s-10___FhWI6 {
  font-size: 10px !important;
}

.BGMChart-module__font-s-12___VJSem {
  font-size: 12px !important;
}

.BGMChart-module__font-s-13___PKEnU {
  font-size: 13px !important;
}

.BGMChart-module__font-s-14___VSF5C {
  font-size: 14px !important;
}

.BGMChart-module__font-s-15___cHLmy {
  font-size: 15px !important;
}

.BGMChart-module__font-s-16___rB5g_ {
  font-size: 16px !important;
}

.BGMChart-module__font-s-18___ak_36 {
  font-size: 18px !important;
}

.BGMChart-module__font-s-20___L7jlY {
  font-size: 20px !important;
}

.BGMChart-module__font-s-22___IOOCD {
  font-size: 22px !important;
}

.BGMChart-module__font-s-28___UBmvv {
  font-size: 28px !important;
}

.BGMChart-module__font-w-400___nahQq {
  font-weight: 400 !important;
}

.BGMChart-module__font-w-500___qMDog {
  font-weight: 500 !important;
}

.BGMChart-module__font-w-600___AlKCB {
  font-weight: 600 !important;
}

.BGMChart-module__font-w-700___QdIIm {
  font-weight: 700 !important;
}

.BGMChart-module__p-5___VSCVT {
  padding: 5px !important;
}

.BGMChart-module__p-12___hKmgK {
  padding: 12px !important;
}

.BGMChart-module__p-16___DD9hn {
  padding: 16px !important;
}

.BGMChart-module__p-30___MYscm {
  padding: 30px !important;
}

.BGMChart-module__p-b-0___xuUOj {
  padding-bottom: 0 !important;
}

.BGMChart-module__p-b-5___U3T4I {
  padding-bottom: 5px !important;
}

.BGMChart-module__p-b-10___eAJ_S {
  padding-bottom: 10px !important;
}

.BGMChart-module__p-b-12___j8Tm3 {
  padding-bottom: 12px !important;
}

.BGMChart-module__p-b-16___Qcoj2 {
  padding-bottom: 16px !important;
}

.BGMChart-module__p-b-18___JNLDM {
  padding-bottom: 18px !important;
}

.BGMChart-module__p-b-20___L1ngp {
  padding-bottom: 20px !important;
}

.BGMChart-module__p-b-25___SYLMp {
  padding-bottom: 25px !important;
}

.BGMChart-module__p-b-30___BNGJh {
  padding-bottom: 30px !important;
}

.BGMChart-module__p-b-50___aOZMZ {
  padding-bottom: 50px !important;
}

.BGMChart-module__p-t-0___YrDNO {
  padding-top: 0 !important;
}

.BGMChart-module__p-t-12___dg4Zj {
  padding-top: 12px !important;
}

.BGMChart-module__p-t-16___qXCFU {
  padding-top: 16px !important;
}

.BGMChart-module__p-t-18___diDJY {
  padding-top: 18px !important;
}

.BGMChart-module__p-t-20___JzVgU {
  padding-top: 20px !important;
}

.BGMChart-module__p-t-30___RN1uO {
  padding-top: 30px !important;
}

.BGMChart-module__p-t-40___gVI0c {
  padding-top: 40px !important;
}

.BGMChart-module__p-t-50___T_umA {
  padding-top: 50px !important;
}

.BGMChart-module__p-l-20___MF1gp {
  padding-left: 20px !important;
}

.BGMChart-module__p-l-30___K4JzI {
  padding-left: 30px !important;
}

.BGMChart-module__p-l-40___IHC7a {
  padding-left: 40px !important;
}

.BGMChart-module__p-r-16___SXpLl {
  padding-right: 16px !important;
}

.BGMChart-module__p-r-20___rEIJx {
  padding-right: 20px !important;
}

.BGMChart-module__p-r-30___rLJ5F {
  padding-right: 30px !important;
}

.BGMChart-module__p-r-50___n5d4V {
  padding-right: 50px !important;
}

.BGMChart-module__p-r-60___o0uGb {
  padding-right: 60px !important;
}

.BGMChart-module__m-b-1___XBK5d {
  margin-bottom: 1px !important;
}

.BGMChart-module__m-b-2___oskvu {
  margin-bottom: 2px !important;
}

.BGMChart-module__m-b-6___ph1DI {
  margin-bottom: 6px !important;
}

.BGMChart-module__m-b-8____N5pu {
  margin-bottom: 8px !important;
}

.BGMChart-module__m-b-10___GivO4 {
  margin-bottom: 10px !important;
}

.BGMChart-module__m-b-14___nMHAK {
  margin-bottom: 14px !important;
}

.BGMChart-module__m-b-16___fCEs2 {
  margin-bottom: 16px !important;
}

.BGMChart-module__m-b-20___JhP0w {
  margin-bottom: 20px !important;
}

.BGMChart-module__m-b-22___XomBs {
  margin-bottom: 22px !important;
}

.BGMChart-module__m-b-24___CyCSd {
  margin-bottom: 24px !important;
}

.BGMChart-module__m-b-30___Vl7R8 {
  margin-bottom: 30px !important;
}

.BGMChart-module__m-b-32___zdJGX {
  margin-bottom: 32px !important;
}

.BGMChart-module__m-b-40___SoESu {
  margin-bottom: 40px !important;
}

.BGMChart-module__m-t-2___KSa68 {
  margin-top: 2px !important;
}

.BGMChart-module__m-t-3___I7eJx {
  margin-top: 3px !important;
}

.BGMChart-module__m-t-4___a9iiv {
  margin-top: 4px !important;
}

.BGMChart-module__m-t-5___KERjk {
  margin-top: 5px !important;
}

.BGMChart-module__m-t-8___ZmT5e {
  margin-top: 8px !important;
}

.BGMChart-module__m-t-10___CRqWi {
  margin-top: 10px !important;
}

.BGMChart-module__m-t-15___ziPp4 {
  margin-top: 15px !important;
}

.BGMChart-module__m-t-16___DQRPu {
  margin-top: 16px !important;
}

.BGMChart-module__m-t-20___MKEng {
  margin-top: 20px !important;
}

.BGMChart-module__m-t-22___TF8UP {
  margin-top: 22px !important;
}

.BGMChart-module__m-t-30___XmGvM {
  margin-top: 30px !important;
}

.BGMChart-module__m-t-32___CVNOC {
  margin-top: 32px !important;
}

.BGMChart-module__m-l-auto___VS1iP {
  margin-left: auto !important;
}

.BGMChart-module__m-l-4___aGtZF {
  margin-left: 4px !important;
}

.BGMChart-module__m-l-5___lZOpW {
  margin-left: 5px !important;
}

.BGMChart-module__m-l-6___kc7RN {
  margin-left: 6px !important;
}

.BGMChart-module__m-l-8___ZbCcz {
  margin-left: 8px !important;
}

.BGMChart-module__m-l-10___xeI_d {
  margin-left: 10px !important;
}

.BGMChart-module__m-l-16___xZTGm {
  margin-left: 16px !important;
}

.BGMChart-module__m-l-20___YXNYk {
  margin-left: 20px !important;
}

.BGMChart-module__m-l-24___Umaym {
  margin-left: 24px !important;
}

.BGMChart-module__m-l-30___FdsOu {
  margin-left: 30px !important;
}

.BGMChart-module__m-l-35___E4sA_ {
  margin-left: 35px !important;
}

.BGMChart-module__m-l-40___tPwuJ {
  margin-left: 40px !important;
}

.BGMChart-module__m-r-8___WmPSR {
  margin-right: 8px !important;
}

.BGMChart-module__m-r-10___JJwnx {
  margin-right: 10px !important;
}

.BGMChart-module__m-r-16___rxJwb {
  margin-right: 16px !important;
}

.BGMChart-module__m-r-20___IS10l {
  margin-right: 20px !important;
}

.BGMChart-module__m-r-24___sORmg {
  margin-right: 24px !important;
}

.BGMChart-module__m-r-30___g9PWs {
  margin-right: 30px !important;
}

.BGMChart-module__m-r-40___H0q4I {
  margin-right: 40px !important;
}

.BGMChart-module__border-r-3___BoMMz {
  border-radius: 3px !important;
}

.BGMChart-module__border-r-4___hNNWp {
  border-radius: 4px !important;
}

.BGMChart-module__border-r-6___dzWnZ {
  border-radius: 6px !important;
}

.BGMChart-module__border-r-10___olLfz {
  border-radius: 10px !important;
}

.BGMChart-module__border-r-12___vMNMi {
  border-radius: 12px !important;
}

.BGMChart-module__border-r-16___C7KW0 {
  border-radius: 16px !important;
}

.BGMChart-module__border-r-50___QfNVT {
  border-radius: 50% !important;
}

.BGMChart-module__primary-border___g0LRA {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMChart-module__primary-border-b___leIDl {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMChart-module__primary-border-t___es6LK {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMChart-module__primary-border-l___rfy7r {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMChart-module__primary-border-r___Qrbb7 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMChart-module__secondary-border___fewnD {
  border: 1px solid #637768;
}

.BGMChart-module__secondary-border-b___OKqfM {
  border-bottom: 1px solid #637768;
}

.BGMChart-module__secondary-border-t___UD84d {
  border-top: 1px solid #637768;
}

.BGMChart-module__secondary-border-l___AjuFa {
  border-left: 1px solid #637768;
}

.BGMChart-module__secondary-border-r___DCU0S {
  border-right: 1px solid #637768;
}

.BGMChart-module__gap-0___G1ZF2 {
  gap: 0 !important;
}

.BGMChart-module__gap-2___JzCXy {
  gap: 2px !important;
}

.BGMChart-module__gap-4___cKQ0I {
  gap: 4px !important;
}

.BGMChart-module__gap-5___JLZsf {
  gap: 5px !important;
}

.BGMChart-module__gap-6___NtJW9 {
  gap: 6px !important;
}

.BGMChart-module__gap-8___ZyyR2 {
  gap: 8px !important;
}

.BGMChart-module__gap-10___qQVTX {
  gap: 10px !important;
}

.BGMChart-module__gap-12___UgrI3 {
  gap: 12px !important;
}

.BGMChart-module__gap-14___ntI0d {
  gap: 14px !important;
}

.BGMChart-module__gap-16___VmwkK {
  gap: 16px !important;
}

.BGMChart-module__gap-18___Psdjt {
  gap: 18px !important;
}

.BGMChart-module__gap-20___pd5ka {
  gap: 20px !important;
}

.BGMChart-module__gap-24___qbOAq {
  gap: 24px !important;
}

.BGMChart-module__gap-26___rdVBl {
  gap: 26px !important;
}

.BGMChart-module__gap-30___S6bBR {
  gap: 30px !important;
}

.BGMChart-module__gap-32___yBl0l {
  gap: 32px !important;
}

.BGMChart-module__gap-40___C9g8n {
  gap: 40px !important;
}

.BGMChart-module__gap-50___jFWJc {
  gap: 50px !important;
}

.BGMChart-module__flex-1___v9fqw {
  flex: 1;
}

.BGMChart-module__flex-none___H_qSo {
  flex: none !important;
}

.BGMChart-module__flex-column___TZAjk {
  display: flex;
  flex-direction: column !important;
}

.BGMChart-module__flex-row___I9xZM {
  display: flex;
  flex-direction: row !important;
}

.BGMChart-module__vertically-centered___Py45Q {
  display: flex;
  align-items: center !important;
}

.BGMChart-module__horizontally-centered___TGtBy {
  display: flex;
  justify-content: center !important;
}

.BGMChart-module__horizontally-end___fbYT8 {
  display: flex;
  justify-content: end !important;
}

.BGMChart-module__vertically-start___RbK39 {
  display: flex;
  align-items: start !important;
}

.BGMChart-module__space-between___xbfm7 {
  display: flex;
  justify-content: space-between !important;
}

.BGMChart-module__flex-wrap___W0_4l {
  flex-wrap: wrap !important;
}

.BGMChart-module__height-100___VGgCY {
  height: 100%;
}

.BGMChart-module__width-50___AJdj4 {
  width: 50% !important;
}

.BGMChart-module__width-100___YAalu {
  width: 100%;
}

.BGMChart-module__cursor-pointer___k8PXl {
  cursor: pointer;
}

.BGMChart-module__cursor-not-allowed___PWFDD {
  cursor: not-allowed !important;
}

.BGMChart-module__absolute-centered___VkfKK {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.BGMChart-module__absolute___ovW14 {
  position: absolute;
}

.BGMChart-module__relative___VonSg {
  position: relative;
}

.BGMChart-module__fixed___ozDME {
  position: fixed;
}

.BGMChart-module__visible___e0v3Z {
  opacity: 1;
}

.BGMChart-module__invisible___PhHjN {
  opacity: 0;
}

.BGMChart-module__col-90___chZ75 {
  width: 90% !important;
}

.BGMChart-module__col-auto___JqJ7B {
  width: auto !important;
}

.BGMChart-module__medical-tabs___QtY3s {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.BGMChart-module__medical-table-new___A3m0C {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.BGMChart-module__medical-table-new___A3m0C:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BGMChart-module__medical-table-new___A3m0C::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BGMChart-module__medical-table-new___A3m0C::-webkit-scrollbar-track {
  display: none;
}
.BGMChart-module__medical-table-new___A3m0C.BGMChart-module__no-pagination___w90KX {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.BGMChart-module__medical-table-new___A3m0C.BGMChart-module__no-pagination___w90KX:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BGMChart-module__medical-table-new___A3m0C.BGMChart-module__no-pagination___w90KX::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BGMChart-module__medical-table-new___A3m0C.BGMChart-module__no-pagination___w90KX::-webkit-scrollbar-track {
  display: none;
}

.BGMChart-module__medical-table-empty___GIvIC {
  padding: 14px 40px !important;
}

.BGMChart-module__icon-btn___hJonl {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.BGMChart-module__search-icon___TgM9g {
  width: 24px;
  height: 24px;
  align-self: center;
}

.BGMChart-module__disable-select___oQZPu {
  user-select: none;
}

.BGMChart-module__break-word___OqV0V {
  word-break: break-word;
}

.BGMChart-module__popup-clear-btn___ITKU2 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.BGMChart-module__scroll-m-b-20___EwOWb {
  scroll-margin-bottom: 20px;
}

.BGMChart-module__container___KGA4c {
  min-height: 46vh;
}
.BGMChart-module__container___KGA4c .BGMChart-module__wrapper___hNQa6 {
  width: 95%;
  height: 40vh;
  position: relative;
  margin-left: 30px;
}
.BGMChart-module__container___KGA4c .BGMChart-module__empty___KsWKV {
  top: 60%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -60%);
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Biometrics/charts/BGMChart/BGMChart.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,gBAAA;AA8pBF;AA5pBE;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AA8pBJ;AA3pBE;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;AA6pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  min-height: 46vh;\n\n  .wrapper {\n    width: 95%;\n    height: 40vh;\n    position: relative;\n    margin-left: 30px;\n  }\n\n  .empty {\n    top: 60%;\n    left: 50%;\n    position: absolute;\n    transform: translate(-50%, -60%);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `BGMChart-module__font-s-10___FhWI6`,
	"fontS12": `BGMChart-module__font-s-12___VJSem`,
	"fontS13": `BGMChart-module__font-s-13___PKEnU`,
	"fontS14": `BGMChart-module__font-s-14___VSF5C`,
	"fontS15": `BGMChart-module__font-s-15___cHLmy`,
	"fontS16": `BGMChart-module__font-s-16___rB5g_`,
	"fontS18": `BGMChart-module__font-s-18___ak_36`,
	"fontS20": `BGMChart-module__font-s-20___L7jlY`,
	"fontS22": `BGMChart-module__font-s-22___IOOCD`,
	"fontS28": `BGMChart-module__font-s-28___UBmvv`,
	"fontW400": `BGMChart-module__font-w-400___nahQq`,
	"fontW500": `BGMChart-module__font-w-500___qMDog`,
	"fontW600": `BGMChart-module__font-w-600___AlKCB`,
	"fontW700": `BGMChart-module__font-w-700___QdIIm`,
	"p5": `BGMChart-module__p-5___VSCVT`,
	"p12": `BGMChart-module__p-12___hKmgK`,
	"p16": `BGMChart-module__p-16___DD9hn`,
	"p30": `BGMChart-module__p-30___MYscm`,
	"pB0": `BGMChart-module__p-b-0___xuUOj`,
	"pB5": `BGMChart-module__p-b-5___U3T4I`,
	"pB10": `BGMChart-module__p-b-10___eAJ_S`,
	"pB12": `BGMChart-module__p-b-12___j8Tm3`,
	"pB16": `BGMChart-module__p-b-16___Qcoj2`,
	"pB18": `BGMChart-module__p-b-18___JNLDM`,
	"pB20": `BGMChart-module__p-b-20___L1ngp`,
	"pB25": `BGMChart-module__p-b-25___SYLMp`,
	"pB30": `BGMChart-module__p-b-30___BNGJh`,
	"pB50": `BGMChart-module__p-b-50___aOZMZ`,
	"pT0": `BGMChart-module__p-t-0___YrDNO`,
	"pT12": `BGMChart-module__p-t-12___dg4Zj`,
	"pT16": `BGMChart-module__p-t-16___qXCFU`,
	"pT18": `BGMChart-module__p-t-18___diDJY`,
	"pT20": `BGMChart-module__p-t-20___JzVgU`,
	"pT30": `BGMChart-module__p-t-30___RN1uO`,
	"pT40": `BGMChart-module__p-t-40___gVI0c`,
	"pT50": `BGMChart-module__p-t-50___T_umA`,
	"pL20": `BGMChart-module__p-l-20___MF1gp`,
	"pL30": `BGMChart-module__p-l-30___K4JzI`,
	"pL40": `BGMChart-module__p-l-40___IHC7a`,
	"pR16": `BGMChart-module__p-r-16___SXpLl`,
	"pR20": `BGMChart-module__p-r-20___rEIJx`,
	"pR30": `BGMChart-module__p-r-30___rLJ5F`,
	"pR50": `BGMChart-module__p-r-50___n5d4V`,
	"pR60": `BGMChart-module__p-r-60___o0uGb`,
	"mB1": `BGMChart-module__m-b-1___XBK5d`,
	"mB2": `BGMChart-module__m-b-2___oskvu`,
	"mB6": `BGMChart-module__m-b-6___ph1DI`,
	"mB8": `BGMChart-module__m-b-8____N5pu`,
	"mB10": `BGMChart-module__m-b-10___GivO4`,
	"mB14": `BGMChart-module__m-b-14___nMHAK`,
	"mB16": `BGMChart-module__m-b-16___fCEs2`,
	"mB20": `BGMChart-module__m-b-20___JhP0w`,
	"mB22": `BGMChart-module__m-b-22___XomBs`,
	"mB24": `BGMChart-module__m-b-24___CyCSd`,
	"mB30": `BGMChart-module__m-b-30___Vl7R8`,
	"mB32": `BGMChart-module__m-b-32___zdJGX`,
	"mB40": `BGMChart-module__m-b-40___SoESu`,
	"mT2": `BGMChart-module__m-t-2___KSa68`,
	"mT3": `BGMChart-module__m-t-3___I7eJx`,
	"mT4": `BGMChart-module__m-t-4___a9iiv`,
	"mT5": `BGMChart-module__m-t-5___KERjk`,
	"mT8": `BGMChart-module__m-t-8___ZmT5e`,
	"mT10": `BGMChart-module__m-t-10___CRqWi`,
	"mT15": `BGMChart-module__m-t-15___ziPp4`,
	"mT16": `BGMChart-module__m-t-16___DQRPu`,
	"mT20": `BGMChart-module__m-t-20___MKEng`,
	"mT22": `BGMChart-module__m-t-22___TF8UP`,
	"mT30": `BGMChart-module__m-t-30___XmGvM`,
	"mT32": `BGMChart-module__m-t-32___CVNOC`,
	"mLAuto": `BGMChart-module__m-l-auto___VS1iP`,
	"mL4": `BGMChart-module__m-l-4___aGtZF`,
	"mL5": `BGMChart-module__m-l-5___lZOpW`,
	"mL6": `BGMChart-module__m-l-6___kc7RN`,
	"mL8": `BGMChart-module__m-l-8___ZbCcz`,
	"mL10": `BGMChart-module__m-l-10___xeI_d`,
	"mL16": `BGMChart-module__m-l-16___xZTGm`,
	"mL20": `BGMChart-module__m-l-20___YXNYk`,
	"mL24": `BGMChart-module__m-l-24___Umaym`,
	"mL30": `BGMChart-module__m-l-30___FdsOu`,
	"mL35": `BGMChart-module__m-l-35___E4sA_`,
	"mL40": `BGMChart-module__m-l-40___tPwuJ`,
	"mR8": `BGMChart-module__m-r-8___WmPSR`,
	"mR10": `BGMChart-module__m-r-10___JJwnx`,
	"mR16": `BGMChart-module__m-r-16___rxJwb`,
	"mR20": `BGMChart-module__m-r-20___IS10l`,
	"mR24": `BGMChart-module__m-r-24___sORmg`,
	"mR30": `BGMChart-module__m-r-30___g9PWs`,
	"mR40": `BGMChart-module__m-r-40___H0q4I`,
	"borderR3": `BGMChart-module__border-r-3___BoMMz`,
	"borderR4": `BGMChart-module__border-r-4___hNNWp`,
	"borderR6": `BGMChart-module__border-r-6___dzWnZ`,
	"borderR10": `BGMChart-module__border-r-10___olLfz`,
	"borderR12": `BGMChart-module__border-r-12___vMNMi`,
	"borderR16": `BGMChart-module__border-r-16___C7KW0`,
	"borderR50": `BGMChart-module__border-r-50___QfNVT`,
	"primaryBorder": `BGMChart-module__primary-border___g0LRA`,
	"primaryBorderB": `BGMChart-module__primary-border-b___leIDl`,
	"primaryBorderT": `BGMChart-module__primary-border-t___es6LK`,
	"primaryBorderL": `BGMChart-module__primary-border-l___rfy7r`,
	"primaryBorderR": `BGMChart-module__primary-border-r___Qrbb7`,
	"secondaryBorder": `BGMChart-module__secondary-border___fewnD`,
	"secondaryBorderB": `BGMChart-module__secondary-border-b___OKqfM`,
	"secondaryBorderT": `BGMChart-module__secondary-border-t___UD84d`,
	"secondaryBorderL": `BGMChart-module__secondary-border-l___AjuFa`,
	"secondaryBorderR": `BGMChart-module__secondary-border-r___DCU0S`,
	"gap0": `BGMChart-module__gap-0___G1ZF2`,
	"gap2": `BGMChart-module__gap-2___JzCXy`,
	"gap4": `BGMChart-module__gap-4___cKQ0I`,
	"gap5": `BGMChart-module__gap-5___JLZsf`,
	"gap6": `BGMChart-module__gap-6___NtJW9`,
	"gap8": `BGMChart-module__gap-8___ZyyR2`,
	"gap10": `BGMChart-module__gap-10___qQVTX`,
	"gap12": `BGMChart-module__gap-12___UgrI3`,
	"gap14": `BGMChart-module__gap-14___ntI0d`,
	"gap16": `BGMChart-module__gap-16___VmwkK`,
	"gap18": `BGMChart-module__gap-18___Psdjt`,
	"gap20": `BGMChart-module__gap-20___pd5ka`,
	"gap24": `BGMChart-module__gap-24___qbOAq`,
	"gap26": `BGMChart-module__gap-26___rdVBl`,
	"gap30": `BGMChart-module__gap-30___S6bBR`,
	"gap32": `BGMChart-module__gap-32___yBl0l`,
	"gap40": `BGMChart-module__gap-40___C9g8n`,
	"gap50": `BGMChart-module__gap-50___jFWJc`,
	"flex1": `BGMChart-module__flex-1___v9fqw`,
	"flexNone": `BGMChart-module__flex-none___H_qSo`,
	"flexColumn": `BGMChart-module__flex-column___TZAjk`,
	"flexRow": `BGMChart-module__flex-row___I9xZM`,
	"verticallyCentered": `BGMChart-module__vertically-centered___Py45Q`,
	"horizontallyCentered": `BGMChart-module__horizontally-centered___TGtBy`,
	"horizontallyEnd": `BGMChart-module__horizontally-end___fbYT8`,
	"verticallyStart": `BGMChart-module__vertically-start___RbK39`,
	"spaceBetween": `BGMChart-module__space-between___xbfm7`,
	"flexWrap": `BGMChart-module__flex-wrap___W0_4l`,
	"height100": `BGMChart-module__height-100___VGgCY`,
	"width50": `BGMChart-module__width-50___AJdj4`,
	"width100": `BGMChart-module__width-100___YAalu`,
	"cursorPointer": `BGMChart-module__cursor-pointer___k8PXl`,
	"cursorNotAllowed": `BGMChart-module__cursor-not-allowed___PWFDD`,
	"absoluteCentered": `BGMChart-module__absolute-centered___VkfKK`,
	"absolute": `BGMChart-module__absolute___ovW14`,
	"relative": `BGMChart-module__relative___VonSg`,
	"fixed": `BGMChart-module__fixed___ozDME`,
	"visible": `BGMChart-module__visible___e0v3Z`,
	"invisible": `BGMChart-module__invisible___PhHjN`,
	"col90": `BGMChart-module__col-90___chZ75`,
	"colAuto": `BGMChart-module__col-auto___JqJ7B`,
	"medicalTabs": `BGMChart-module__medical-tabs___QtY3s`,
	"medicalTableNew": `BGMChart-module__medical-table-new___A3m0C`,
	"noPagination": `BGMChart-module__no-pagination___w90KX`,
	"medicalTableEmpty": `BGMChart-module__medical-table-empty___GIvIC`,
	"iconBtn": `BGMChart-module__icon-btn___hJonl`,
	"searchIcon": `BGMChart-module__search-icon___TgM9g`,
	"disableSelect": `BGMChart-module__disable-select___oQZPu`,
	"breakWord": `BGMChart-module__break-word___OqV0V`,
	"popupClearBtn": `BGMChart-module__popup-clear-btn___ITKU2`,
	"scrollMB20": `BGMChart-module__scroll-m-b-20___EwOWb`,
	"container": `BGMChart-module__container___KGA4c`,
	"wrapper": `BGMChart-module__wrapper___hNQa6`,
	"empty": `BGMChart-module__empty___KsWKV`
};
module.exports = ___CSS_LOADER_EXPORT___;
